import {action} from "typesafe-actions";
import { WelcomeMsg } from "../types/common-types";
import {FeedbackMsg} from "../types/chat-feedback-types";

export enum ChatCommonActions {
    GET_WELCOME_MESSAGE = "ChatCommonActions/GET_WELCOME_MESSAGE",
    SET_WELCOME_MESSAGE_RESULT = "ChatCommonActions/SET_WELCOME_MESSAGE_RESULT",
    LAST_RESPONSE_TIME = "ChatCommonActions/LAST_RESPONSE_TIME",
    SUBMIT_FEEDBACK = "ChatCommonActions/SUBMIT_FEEDBACK"
};
export const getWelcomeMsgAction = () => action(ChatCommonActions.GET_WELCOME_MESSAGE);
export const setWelcomeMsgResultAction = (welcomeMsg: WelcomeMsg) => action(ChatCommonActions.SET_WELCOME_MESSAGE_RESULT, welcomeMsg);
export const setLastResponseTimeAction = () => action(ChatCommonActions.LAST_RESPONSE_TIME);
export const submitFeedbackAction = (feedbackMsg:FeedbackMsg) => action(ChatCommonActions.SUBMIT_FEEDBACK,feedbackMsg);
